$(document).on('click', '.filter-price__trigger', function() {
  $(this).toggleClass('se-active');
  $('.se-filters-popup').toggleClass('se-opened');
  $('.se-overlay').toggleClass('se-opened');
  $('body').toggleClass('se-opened');
});
$(document).on('click', '.se-filter-close', function() {
  $('.se-filters-popup').removeClass('se-opened');
  $('.se-filter-trigger').removeClass('se-active');
  $('.se-overlay').removeClass('se-opened');
  $('body').removeClass('se-opened');
});
$(document).on('click', '.se-filter-apply', function() {
  $('.filter-form').submit();
  setTimeout(function(){
    $('.se-filters-popup').removeClass('se-opened');
    $('.se-filter-trigger').removeClass('se-active');
  }, 200);
});

$(document).on('click', '.se-filter-label', function (e) {
  var seValue = $(this).attr('data-value');
  $(this).toggleClass('se-selected');
  $('.se-filter[data-value="'+seValue+'"]').click();
  $(this).css('--custom-color', seValue.toLowerCase());
  setTimeout(function(){
    const seCustomFilter = new Event("seCustomFilter");
    document.dispatchEvent(
      new CustomEvent("seCustomFilter", {})
    );
  }, 200);
});
  
document.addEventListener("seCustomFilter", e => {
  var seURLDef = window.location.href;
  var seSort = '';
  if(seURLDef.indexOf('sort_by') != -1){
    seURLDef = seURLDef.split('sort_by=')[1];
    seURLDef = seURLDef.split('&')[0];
    seSort = '?sort_by='+seURLDef+'&';
  }
  var seURL = window.location.href.split('?')[1];
  $.ajax({
    url: window.location.pathname+'?section_id=se-filters&'+seSort+seURL,
    type: 'GET',
    dataType: 'html',
    success: function(data) {
      $('.se-filters-ajax').html(data);
    },
    error: function(jqXHR, textStatus, errorThrown) {
      console.error("Error fetching se-filters content:", errorThrown);
    }
  });
});
$(document).on('click', '.se-sort-option', function() {
  var seValue = $(this).attr('data-option-value');
  $('.se-sort-option').removeClass('se-sort-active');
  $(this).addClass('se-sort-active');
  $('.se-sort-default[data-option-value="'+seValue+'"]').trigger('click');
});
$(document).on('click', '.se-filter-show', function() {
  $('.se-filters-popup').removeClass('se-opened');
  $('.se-filter-trigger').removeClass('se-active');
  $('.se-overlay').removeClass('se-opened');
  $('body').removeClass('se-opened');
});
$(document).on('change', '.se-range-min', function() {
  $('.se-filter-min').val($(this).val());
  $('.se-min-value').val($(this).val());
  $('.se-filter-min').trigger('change');
});
$(document).on('change', '.se-range-max', function() {
  $('.se-filter-max').val($(this).val());
  $('.se-max-value').val($(this).val());
  $('.se-filter-max').trigger('change');
});
$(document).on('change', '.se-min-value', function() {
  $('.se-filter-min').val($(this).val());
  $('.se-filter-min').trigger('change');
});
$(document).on('change', '.se-max-value', function() {
  $('.se-filter-max').val($(this).val());
  $('.se-filter-max').trigger('change');
}); 
$(document).on('click', '.js-current-filter', function() {
  setTimeout(function(){
    const seCustomFilter = new Event("seCustomFilter");
    document.dispatchEvent(
      new CustomEvent("seCustomFilter", {})
    );
  }, 200);
}); 

/* SE - Custom button - 05 May '25 */
document.addEventListener('DOMContentLoaded', function () {
  const targetSelector = '.Rise__widget-launcher';
  const buttonSelector = '.se-rewards-wrapper';

  const observer = new MutationObserver((mutations, obs) => {
    const widget = document.querySelector(targetSelector);
    if (widget) {
      const button = document.querySelector(buttonSelector);
      if (button) {
        button.classList.add('se-rewards-active');
      }
      obs.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
